import './HomeSection.scss'
import React from 'react'
import classnames from 'classnames'
import { Background } from '../lib'

const HomeSection = ({ children, background, className }) => {
  return (
    <section className={classnames('HomeSection', className)}>
      {background &&
        <Background className='HomeSection_background' src={background} />
      }
      <div className='HomeSection_content'>
        {children}
      </div>
    </section>
  )
}

HomeSection.displayName = 'HomeSection'

export default HomeSection



// WEBPACK FOOTER //
// ./src/home/HomeSection.js